"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangeOptionList = void 0;
var react_1 = __importDefault(require("react"));
var __1 = require("../..");
var utils_1 = require("../utils");
var DateRangeOptionList = function (_a) {
    var options = _a.options, min = _a.min, max = _a.max, onChange = _a.onChange;
    var normalizeValueInOptions = options.map(function (option) {
        return __assign(__assign({}, option), { value: {
                start: utils_1.toDateFormat.startOfDay(option.value.start),
                end: utils_1.toDateFormat.endOfDay(option.value.end),
            } });
    });
    var checkOptions = normalizeValueInOptions.filter(function (option) {
        var isOutOfScope = utils_1.checkScope(option.value, min, max);
        if (isOutOfScope.startOutOfScope || isOutOfScope.endOutOfScope)
            return false;
        return true;
    });
    var handleOnChange = function (data) {
        onChange(data);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, checkOptions.length > 0 && (react_1.default.createElement("div", { className: "DateRangePicker__options" },
        react_1.default.createElement(__1.OptionList, { options: checkOptions, onChange: function (data) { return handleOnChange(data); } })))));
};
exports.DateRangeOptionList = DateRangeOptionList;
//# sourceMappingURL=DateRangeOptionList.js.map